var map = {
	"./close-eye.svg": 14703,
	"./close.svg": 36205,
	"./confirm.svg": 32571,
	"./delete.svg": 45355,
	"./download.svg": 79681,
	"./edits.svg": 56187,
	"./eye.svg": 87655,
	"./logo.svg": 29762,
	"./menu-down.svg": 73057,
	"./menu-up.svg": 80205,
	"./password.svg": 69006,
	"./pdf.svg": 51561,
	"./phone.svg": 5887,
	"./right.svg": 39250,
	"./search.svg": 29977,
	"./upload.svg": 23888,
	"./user.svg": 52875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49566;